import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, QuestionnaireCount,  } from "../store_types"
import { callCountAnytimeConsultationQuestionnairesAPI, callCountNightConsultationQuestionnairesAPI, callCountDaytimeAdviceQuestionnairesAPI } from "../../api/count_questionnaire"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    anytimeConsultationQuestionnaireCount: null,
    nightConsultationQuestionnaireCount: null,
    daytimeAdviceQuestionnaireCount: null
  }
}

const questionnaireCount = {
  state: () => getDefaultState(),

  getters: {
    anytimeConsultationQuestionnaireCount (state : State) {
      return state.anytimeConsultationQuestionnaireCount
    },
    nightConsultationQuestionnaireCount (state : State) {
      return state.nightConsultationQuestionnaireCount
    },
    daytimeAdviceQuestionnaireCount (state : State) {
      return state.daytimeAdviceQuestionnaireCount
    },
  },

  actions: {
    fetchAnytimeConsultationCount({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | QuestionnaireCount) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callCountAnytimeConsultationQuestionnairesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireAnalyticsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, anytimeConsultationQuestionnaireCount: QuestionnaireCount) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_ANYTIME_CONSULTATION_QUESTIONNAIRE_COUNT, anytimeConsultationQuestionnaireCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    fetchNightConsultationCount({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | QuestionnaireCount) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callCountNightConsultationQuestionnairesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireAnalyticsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, nightConsultationQuestionnaireCount: QuestionnaireCount) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_NIGHT_CONSULTATION_QUESTIONNAIRE_COUNT, nightConsultationQuestionnaireCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    fetchDaytimeAdviceCount({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | QuestionnaireCount) => void, getters: { [authHeaders: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callCountDaytimeAdviceQuestionnairesAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireAnalyticsDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, daytimeAdviceQuestionnaireCount: QuestionnaireCount) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_DAYTIME_ADVICE_QUESTIONNAIRE_COUNT, daytimeAdviceQuestionnaireCount)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    resetQuestionnaireCountState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_QUESTIONNAIRE_COUNT_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_ANYTIME_CONSULTATION_QUESTIONNAIRE_COUNT](state: State, anytimeConsultationQuestionnaireCount: QuestionnaireCount) {
      state.anytimeConsultationQuestionnaireCount = anytimeConsultationQuestionnaireCount
    },
    [MutationTypes.ASSIGN_NIGHT_CONSULTATION_QUESTIONNAIRE_COUNT](state: State, nightConsultationQuestionnaireCount: QuestionnaireCount) {
      state.nightConsultationQuestionnaireCount = nightConsultationQuestionnaireCount
    },
    [MutationTypes.ASSIGN_DAYTIME_ADVICE_QUESTIONNAIRE_COUNT](state: State, daytimeAdviceQuestionnaireCount: QuestionnaireCount) {
      state.daytimeAdviceQuestionnaireCount = daytimeAdviceQuestionnaireCount
    },
    [MutationTypes.RESET_QUESTIONNAIRE_COUNT_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default questionnaireCount
